import { render, staticRenderFns } from "./FormTypesTipPrudence.vue?vue&type=template&id=408ec02c"
import script from "./FormTypesTipPrudence.vue?vue&type=script&lang=js"
export * from "./FormTypesTipPrudence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports